import { FunctionComponent } from "react";

import { LeadPanelCondensedHeader } from "@/pages/Private/pages/Contacts/components/LeadPanelCondensedHeader";

import { ListPerson } from "../../../schema/list";

type Prospect = NonNullable<ListPerson["prospect"]>;
type Offer = ListPerson["offer"];
type Organization = NonNullable<Prospect["organization"]>;

/**
 * The list / Messages detail panel's condensed name strip: the shared
 * {@link LeadPanelCondensedHeader} fed from this panel's lead, which carries its identity across
 * three places — the prospect, the job offer it was matched from, and the organization.
 *
 * Extracted so that mapping lives beside the types it reads rather than inside a panel that is at
 * the 500-line ceiling.
 */
export const DetailViewCondensedHeader: FunctionComponent<{
	visible: boolean;
	prospect?: Prospect;
	offer?: Offer;
	organization?: Organization | null;
}> = ({ visible, prospect, offer, organization }) => (
	<LeadPanelCondensedHeader
		companyName={organization?.name ?? offer?.companyName}
		email={prospect?.email ?? offer?.email}
		emailStatus={prospect?.emailStatus ?? offer?.emailStatus}
		image={prospect?.image}
		linkedinUrl={prospect?.linkedinUrl}
		name={prospect?.name ?? offer?.name}
		overallReasoning={prospect?.scorePersonaCategoryResult?.overallReasoning}
		overallScore={prospect?.scorePersonaCategoryResult?.overallScore}
		scoring={prospect?.scorePersonaCategoryResult}
		phone={organization?.phone}
		title={prospect?.title ?? offer?.title}
		visible={visible}
	/>
);
